import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from '../../../app/servicios/api/api.service';
import { fuenteI } from '../../../app/modelos/fuentes.interface';
import { OperacionI } from '../../../app/modelos/operacionEsta.interface';

@Component({
  selector: 'app-variablesfivi',
  templateUrl: './variablesfivi.component.html',
  styleUrls: ['./variablesfivi.component.css']
})
export class VariablesfiviComponent implements OnDestroy,OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  Operacion:OperacionI;
  fuentesFivi : fuenteI[];

  constructor(private api:ApiService, private router:Router) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ entradas"
        }
    };

    let operacion: OperacionI;
    operacion = new OperacionI();
    operacion.id =2;
    operacion.descripcion= "Financiacion de Vivienda";
    operacion.nombre = "FIVI";
    this.api.getFuentesByOpe(operacion).subscribe(data=>{
      this.dtTrigger.next();
      this.fuentesFivi = data;
      for (let fte of this.fuentesFivi){
        this.api.getdeptoByCod(fte.depto).subscribe(depto0=>{
          fte.depto = depto0.nombre;
        });
        this.api.getMuniByCodigo(fte.muni).subscribe(muni0=>{
          fte.muni = muni0.nommpio;
        });
      }
    },error=>{
      console.log(error);
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  goAdminVaribles(id){
    this.router.navigate(['administrarvariablesfivi', id]);
  }

  regresarDirectorio(){
    this.router.navigate(['directorio']);
  }

}
